import '@/assets/scss/style.scss'
import 'vue-toastification/dist/index.css'
import { createApp } from 'vue'
import App from './App.vue'
import Toast from 'vue-toastification'
import VueGtag from 'vue-gtag'
import router from './router'

const app = createApp(App)
app.use(router)
app.use(Toast)
app.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_ID }
})
app.mount('#contact-app')
